import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { EVENT_TYPE } from 'shared/utils/mixpanel';
import { useTrackEvent } from './useTrackEvent';
export var useTrackedRoutes = function () {
    var location = useLocation();
    var trackEvent = useTrackEvent();
    useEffect(function () {
        trackEvent(EVENT_TYPE.PAGE_VIEWED, location.pathname, 'Page Change');
    }, [location.pathname]);
};
